import { NgModule } from '@angular/core'
import { ConfigModule, UrlModule } from '@spartacus/core'
import { MbSubmitOrderPriceComponent } from './mb-submit-order-price/mb-submit-order-price.component'
import { MbSubmitOrderRequestComponent } from './mb-submit-order-request/mb-submit-order-request.component'
import { CommonModule } from '@angular/common'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { RouterModule } from '@angular/router'
import {
  MbSubmitOrderTermConditionComponent
} from './mb-submit-order-term-condition/mb-submit-order-term-condition.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MbFormErrorsModule } from '../../../shared/components/mb-form-errors/mb-form-errors.module'
import {
  MbCheckoutReviewBaseComponent
} from '../../../checkout/components/mb-checkout-review/mb-checkout-review-base.component'
import { MbSubmitOrderCartComponent } from './mb-submit-order-cart/mb-submit-order-cart.component'
import { MbSubmitOrderStepsComponent } from './mb-submit-order-steps/mb-submit-order-steps.component'
import { MbSubmitOrderReviewComponent } from './mb-submit-order-review/mb-submit-order-review.component'
import { MbSubmitOrderConfirmationComponent } from './mb-submit-order-confirmation/mb-submit-order-confirmation.component'
import { SafeHtmlModule } from 'src/app/mb/cms/pipes/sanitize-html/safe-html.module'
import { DirectiveModule } from '../../../shared/directive.module'
import { MbPaymentMethodsModule } from '../mb-payment-methods/mb-payment-methods.module'

@NgModule({
  imports: [
    ConfigModule.withConfig({
      cmsComponents: {
        MiltenyiOrderSummaryComponent: {
          component: MbSubmitOrderStepsComponent
        },
        MiltenyiCartPageOrderSummaryComponent: {
          component: MbSubmitOrderCartComponent
        },
        MiltenyiReviewPageOrderSummaryComponent: {
          component: MbSubmitOrderReviewComponent
        },
        MiltenyiConfirmationPageOrderSummaryComponent: {
          component: MbSubmitOrderConfirmationComponent
        }
      }
    }),
    CommonModule,
    MbI18nModule,
    RouterModule,
    UrlModule,
    ReactiveFormsModule,
    MbFormErrorsModule,
    SafeHtmlModule,
    DirectiveModule,
    MbPaymentMethodsModule
  ],
  providers: [MbCheckoutReviewBaseComponent],
  exports: [
    MbSubmitOrderPriceComponent,
    MbSubmitOrderRequestComponent,
    MbSubmitOrderConfirmationComponent,
  ],
  declarations: [
    MbSubmitOrderPriceComponent,
    MbSubmitOrderRequestComponent,
    MbSubmitOrderTermConditionComponent,
    MbSubmitOrderCartComponent,
    MbSubmitOrderStepsComponent,
    MbSubmitOrderReviewComponent,
    MbSubmitOrderConfirmationComponent
  ]
})

export class MbSubmitOrderModule {
}
